import http from 'utils/http';
import { getAgencyAddonUrl, getAgencyAddonsUrl } from './apiUrls';
import { AgencyAddon, UpdateAgencyAddonPayload } from './types';
import { MetaApiResponse } from 'utils/types/CommonApiResponse';

export function getAgencyAddons(params?: Record<string, unknown>): Promise<{
  data: AgencyAddon[];
  meta?: MetaApiResponse;
}> {
  return http.get(getAgencyAddonsUrl(), params);
}

export function updateAgencyAddon(id: string | number, payload: UpdateAgencyAddonPayload): Promise<AgencyAddon> {
  return http.patch(getAgencyAddonUrl(id), payload);
}
